module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-east-west-coast/key-1-2015.svg?v=0d1e8cd0";